import { render } from "./OptionsLabel.vue?vue&type=template&id=49495a05"
import script from "./OptionsLabel.vue?vue&type=script&lang=js"
export * from "./OptionsLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__